if (!customElements.get('skph-audio-player')) {
  customElements.define('skph-audio-player', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.querySelectorAll('[data-audio-row]').forEach((row) => {
        const audio = row.querySelector('audio');
        const play = row.querySelector('[data-play]');
        const range = row.querySelector('[data-range]');
        const time = row.querySelector('[data-time]');
        if (!audio || !play || !range || !time) return;
        const format = (value) => `${Math.floor(value / 60)}:${String(Math.floor(value % 60)).padStart(2, '0')}`;
        audio.addEventListener('loadedmetadata', () => { time.textContent = format(audio.duration || 0); });
        audio.addEventListener('timeupdate', () => { range.value = audio.duration ? (audio.currentTime / audio.duration) * 100 : 0; });
        audio.addEventListener('ended', () => { play.textContent = '▶'; range.value = 0; });
        play.addEventListener('click', () => {
          document.querySelectorAll('skph-audio-player audio').forEach((other) => {
            if (other !== audio) { other.pause(); const b = other.closest('[data-audio-row]')?.querySelector('[data-play]'); if (b) b.textContent = '▶'; }
          });
          if (audio.paused) { audio.play(); play.textContent = '❚❚'; } else { audio.pause(); play.textContent = '▶'; }
        });
        range.addEventListener('input', () => { if (audio.duration) audio.currentTime = (range.value / 100) * audio.duration; });
      });
    }
  });
}